videojs.addLanguage('ru', {
  "AdBlockers warning": "Предупреждение",
  "Off adBlockers to watch normaly": function() {
  	let strong = document.createElement("strong");
  	strong.innerHTML = 'расширение браузера для блокирования рекламы';
  	return [document.createTextNode("Похоже, что вы используете "), 
  		strong,
  		document.createTextNode(". Качество видео будет понижено."), 
  		document.createElement("br"), 
  		document.createElement("br"),
  		document.createTextNode("Отключите блокировщик рекламы и обновите страницу для возможности управления качествами и просмотра в высоком разрешении.")];
  }
});